import type { ConfigDisplayOptions } from '@az/middleware/src/__generated__/gql/graphql';

export const useCheckIfValueExistsInDisplayOptions = (
  value: string,
  displayOptions: ConfigDisplayOptions[] | ConfigDisplayOptions,
): boolean => {
  if (Array.isArray(displayOptions)) {
    return displayOptions.some((displayOption) => displayOption.fields?.value === value);
  } else {
    return displayOptions.fields?.value === value;
  }
};
